export default __webpack_public_path__ + "img/4014ca473cdade48dc20758b68ca0bb7.svg";